// Vue
import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Libraries
import videojs from "video.js";
import "videojs-youtube";
import "./Vimeo";
import { getCookie, setCookie } from "../../../utils/cookie";
import { H } from "../h/H";
import { P } from "../p/P";
import { ButtonLink } from "../button_link/ButtonLink";
import { nextTick } from "vue";

@Component({
  name: "Video",
  mixins: [template],
  components: {
    MgsH: H,
    MgsP: P,
    MgsButtonLink: ButtonLink,
  },
})
export class Video extends Vue {
  private hasBeenStarted: boolean = false;

  private player: videojs.Player | null = null;

  @Inject({ from: "marketingCookies" })
  public marketingCookies: string[] = [];

  showPoster: boolean = true;
  loadVideo: boolean = true;

  @Prop({ default: false })
  public autoplay!: boolean;

  @Prop({ default: false })
  public autoplayOnlyVisible!: boolean;

  @Prop({ default: true })
  public autoplayMuted!: boolean;

  @Prop()
  public poster!: string;

  @Prop()
  public loop!: boolean;

  @Prop({ default: true })
  public controls!: boolean;

  @Prop()
  public src!: string;

  @Prop({ default: () => [] })
  public events!: string[];

  @Prop({ default: 450 })
  public posterHeight?: number;

  public $refs!: {
    video: HTMLElement;
    posterWrapper: HTMLElement;
  };

  public created() {
    document.addEventListener("scroll", this.handleScroll);
  }

  public mounted() {
    if (this.posterHeight && this.$refs.posterWrapper) {
      this.$refs.posterWrapper.style.minHeight = this.posterHeight + "px";
    }

    this.marketingCookies = getCookie("marketing-cookies") ? JSON.parse(getCookie("marketing-cookies")) : [];

    if (this.getVideoType() === "video/youtube") {
      this.loadVideo = this.isYoutubeCookieAccepted;
    }

    this.showPoster = !!this.poster;

    if (this.loadVideo) this.initVideo();
  }

  public destroyed() {
    document.removeEventListener("scroll", this.handleScroll);

    this.events.forEach((event) => {
      this.$refs.video.removeEventListener(event, (e) => this.$emit(event, e));
    });
  }

  get isYoutubeCookieAccepted() {
    return this.marketingCookies.includes("youtube");
  }

  public videoJsConfig() {
    let sources = [] as any[];
    sources.push({
      type: this.getVideoType(),
      src: this.src,
    });

    return {
      poster: this.poster,
      loop: this.loop,
      controls: this.controls,
      fluid: true,
      muted: this.autoplay && this.autoplayMuted,
      techOrder: ["youtube", "vimeo", "html5"],
      youtube: {
        enablePrivacyEnhancedMode: true,
      },
      width: 640,
      height: 264,
      sources,
    };
  }

  public initVideo() {
    nextTick(() => {
      this.player = videojs(this.$refs.video, this.videoJsConfig())!;

      this.events.forEach((event) => {
        this.player!.on(event, (e) => {
          this.$emit(event, e);
        });
      });

      if (!this.autoplayOnlyVisible && this.autoplay) this.player.play();

      console.log(this.player);
    });
  }

  public getVideoType() {
    if (this.src) {
      if (this.src.includes("youtube")) {
        return "video/youtube";
      } else if (this.src.includes("vimeo")) {
        return "video/vimeo";
      } else {
        return "video/mp4";
      }
    } else {
      return "";
    }
  }

  public handleScroll(e: Event) {
    if (!this.autoplayOnlyVisible || !this.autoplay) return;

    if (this.isVideoVisible() && !this.hasBeenStarted) {
      this.player!.play();

      this.hasBeenStarted = true;
    }
  }

  public isVideoVisible() {
    const rect = this.$el.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  }

  public onAcceptClick() {
    console.log("onAcceptClick");
    this.marketingCookies.push("youtube");
    setCookie("marketing-cookies", JSON.stringify(this.marketingCookies));

    if (this.getVideoType() === "video/youtube") {
      this.loadVideo = this.isYoutubeCookieAccepted;
    }

    if (this.loadVideo) this.initVideo();

    this.$emit("cookieAccept");
  }

  @Inject({ from: "CI2019HandleFooterClick" })
  public handleFooterClick;

  public onMoreInfoClick() {
    //console.log("onMoreInfoClick");

    if (this.handleFooterClick) {
      this.handleFooterClick("cookies");
    }

    this.$emit("moreInfo");
  }

  public onPosterLoadError() {
    this.showPoster = false;
  }
}
